import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { instanceToModule, returnsPromise, unsupported } from './connect/Util';
let User = (_class = class User {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  async getCurrentUser() {
    const response = await fetchOk('/gateway/api/me');
    const result = await response.json();
    return {
      atlassianAccountId: result.account_id,
      name: result.name,
      avatarUrl: result.picture,
      email: result.email
    };
  }
  revokeUserGrant(_options) {
    return Promise.reject();
  }
}, _applyDecoratedDescriptor(_class.prototype, "getCurrentUser", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "getCurrentUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revokeUserGrant", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "revokeUserGrant"), _class.prototype), _class);
export default config => instanceToModule(new User(config));